import React from "react";
export default function Filter(props) {
  return (
    <div className="filter px-4 ">
      <div className="filterleft">
        <button className={"NavLinkBtn hover marginright unselectlink"}>
          Records : {props.records}
        </button>
      </div>
      <div className="filterright"></div>
    </div>
  );
}
